import css from "../../css/listing/get-more-info.module.css";

import React from "react";
import PropTypes from "prop-types";
import Agent from "./Agent";
import GetMoreInfoForm from "./GetMoreInfoForm";

const GetMoreInfo = (props) => {
    const { listing, agents } = props;

    return (
        <div className={css.getMoreInfo}>
            <div className={css.agents}>
                {agents.map((agent, i) => (
                    <div
                        className={i === 0 ? css.agentPrimary : css.agent}
                        key={agent.id}
                    >
                        <Agent
                            agent={agent}
                            listing={listing}
                            isPrimary={i === 0}
                        />
                    </div>
                ))}
            </div>
            <div className={css.form}>
                <GetMoreInfoForm listing={listing} />
            </div>
        </div>
    );
};

GetMoreInfo.propTypes = {
    listing: PropTypes.object.isRequired,
    agents: PropTypes.array.isRequired,
};

export default GetMoreInfo;
